import $api from "@/zapi-frontend/shared/api/axios";
import { GetClaimsSchema, TClaims } from "../model/types";

export async function getClaims({ projectId, chapterId }: { projectId: string; chapterId: string }) {
  const response = await $api.get<TClaims>(`/claims`, {
    params: {
      projectId,
      projectChapterId: chapterId
    }
  });

  const data = GetClaimsSchema.parse(response.data);

  return data;
}
